import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NavHeader from "@/components/NavHeader";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { LogIn, Skull, Users } from "lucide-react";

export default function ChronicleJoin() {
  const { code } = useParams();
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const attempted = useRef(false);
  const [status, setStatus] = useState("waiting"); // waiting | joining | joined | error
  const [error, setError] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user) return;
    if (attempted.current) return;
    attempted.current = true;
    (async () => {
      setStatus("joining");
      try {
        const r = await api.post("/chronicles/join", { code: (code || "").toUpperCase() });
        toast.success(r.data.already_member ? "REJOINED CHRONICLE" : "JOINED CHRONICLE");
        navigate(`/chronicle/${r.data.chronicle_id}`, { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Join failed");
        setStatus("error");
      }
    })();
  }, [loading, user, code, navigate]);

  return (
    <div className="min-h-screen scanlines">
      <NavHeader />
      <main className="max-w-[720px] mx-auto px-4 sm:px-6 py-16 text-center">
        {!user && !loading && (
          <>
            <Users className="mx-auto text-[color:var(--accent-cyan)]" size={64} />
            <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tighter mt-4">
              CHRONICLE INVITE
            </h1>
            <div className="font-display text-4xl sm:text-5xl font-black tracking-widest text-[color:var(--accent-yellow)] mt-2">
              {code?.toUpperCase()}
            </div>
            <p className="font-mono text-sm text-[color:var(--text-secondary)] mt-3">
              Sign in to jack into this chronicle.
            </p>
            <button onClick={login} data-testid="join-signin-btn" className="cy-btn cy-btn-solid-yellow mt-6">
              <LogIn size={16} className="mr-2" /> SIGN IN TO JOIN
            </button>
          </>
        )}
        {user && status === "joining" && (
          <div className="panel panel-cyan p-8">
            <div className="font-display text-2xl uppercase tracking-widest text-[color:var(--accent-cyan)]">
              JACKING IN...
            </div>
            <div className="mt-2 font-mono text-xs text-[color:var(--text-muted)]">Chronicle {code?.toUpperCase()}</div>
          </div>
        )}
        {status === "error" && (
          <div className="panel panel-magenta p-8">
            <Skull className="mx-auto text-[color:var(--accent-magenta)]" size={48} />
            <div className="font-display text-2xl uppercase mt-2">JOIN FAILED</div>
            <div className="font-mono text-sm text-[color:var(--text-secondary)] mt-1">{error}</div>
            <button onClick={() => navigate("/chronicles")} className="cy-btn mt-4">CHRONICLES</button>
          </div>
        )}
      </main>
    </div>
  );
}
